<script>
import Layout from '@layouts/adminLayout.vue'
import MyInfoView from '@views/settings/my-info.vue'
import router from '@router'
import { authComputed } from '@state/helpers'
export default {
  page: {
    title: 'Debug Personnel Management',
    meta: [{ name: 'description', content: 'The Debug Personnel Management page.' }],
  },
  components: { Layout, MyInfoView },
  data() {
    return {
      debugStarted: false,
      debugUserId: null,
    }
  },
  computed: {
    ...authComputed,
  },
  created() {
    if (!this.canImpersonate) {
      router.push({ name: 'myInfo' })
    }
  },
}
</script>

<template>
  <Layout>
    <div class="d-flex align-items-center w-25 mb-2">
      User Id: <BaseInputText v-model="debugUserId" :disabled="debugStarted" class="ml-2" label="User Id" />
    </div>
    <BaseButton :disabled="!debugUserId" @click="debugStarted = !debugStarted">{{
      debugStarted ? 'Stop impersonating' : 'Start impersonating'
    }}</BaseButton>
    <MyInfoView v-if="debugStarted" debug-mode="yes" :debug-user-id="parseInt(debugUserId)"></MyInfoView>
  </Layout>
</template>
